import { Box } from '@rbilabs/universal-components';

export const ProductItemFlowContainer = Box.withConfig({
  width: 'full',
});
